// // import { apiCall } from "./index";

// // // Overtime API endpoints
// // export const getOvertimeRequests = (params = {}) => {
// //   const queryParams = new URLSearchParams(params).toString();
// //   return apiCall(`/overtime/request?${queryParams}`);
// // };

// // export const getOvertimeRequestById = (requestId) =>
// //   apiCall(`/overtime/request/${requestId}`);

// // export const createOvertimeRequest = (requestData) =>
// //   apiCall(`/overtime/request`, "POST", requestData);

// // export const updateOvertimeRequest = (requestId, requestData) =>
// //   apiCall(`/overtime/request/${requestId}`, "PUT", requestData);

// // export const deleteOvertimeRequest = (requestId) =>
// //   apiCall(`/overtime/request/${requestId}`, "DELETE");

// // export const approveOvertimeRequest = (requestId) =>
// //   apiCall(`/overtime/request/${requestId}/approve`, "PATCH");

// // export const rejectOvertimeRequest = (requestId, reason = "") =>
// //   apiCall(`/overtime/request/${requestId}/reject`, "PATCH", { reason });

// // export const getOvertimeSummary = (userId, params = {}) => {
// //   const queryParams = new URLSearchParams(params).toString();
// //   return apiCall(`/overtime/summary/${userId}?${queryParams}`);
// // };

// // export const getPendingOvertimeRequests = (params = {}) => {
// //   const queryParams = new URLSearchParams(params).toString();
// //   return apiCall(`/overtime/pending?${queryParams}`);
// // };

// // api/attendance.js
// import { apiCall } from "./index";

// // Overtime API endpoints
// export const getMyOvertimeRequests = (params = {}) => {
//   const queryParams = new URLSearchParams(params).toString();
//   return apiCall(`/overtime/my-requests?${queryParams}`);
// };

// export const getOvertimeRequests = () =>
//   apiCall(`/overtime/request`);

// export const createOvertimeRequest = (requestData) =>
//   apiCall(`/overtime/request`, "POST", requestData);

// export const updateOvertimeRequest = (requestId, requestData) =>
//   apiCall(`/overtime/request/${requestId}`, "PUT", requestData);

// export const deleteOvertimeRequest = (requestId) =>
//   apiCall(`/overtime/request/${requestId}`, "DELETE");

// export const approveOvertimeRequest = (requestId) =>
//   apiCall(`/overtime/${requestId}/approve`, "POST");

// export const rejectOvertimeRequest = (requestId, reason = "") =>
//   apiCall(`/overtime/${requestId}/reject`, "POST", { reason });

// export const cancelOvertimeRequest = (requestId, cancelReason = "") =>
//   apiCall(`/overtime/${requestId}/cancel`, "POST", { cancel_reason: cancelReason });





// api/attendance.js
import { apiCall } from "api";

// Overtime API endpoints
export const getMyOvertimeRequests = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/overtime/my-requests?${queryParams}`);
};

export const getOvertimeRequests = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/overtime/request?${queryParams}`);
};


export const getAttendenceStatus = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/attendance/status?${queryParams}`);
};
 

export const getOvertimeHistory = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/overtime/all-overtimes-history?${queryParams}`);
};

export const attendenceTeam = (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return apiCall(`/team-attendance-summary?${queryParams}`);
};

export const createOvertimeRequest = (requestData) =>
  apiCall(`/overtime/request`, "POST", requestData);

export const updateOvertimeRequest = (requestId, requestData) =>
  apiCall(`/overtime/request/${requestId}`, "PUT", requestData);

export const deleteOvertimeRequest = (requestId) =>
  apiCall(`/overtime/request/${requestId}`, "DELETE");

export const approveOvertimeRequest = (requestId,status_reason = "") =>
  apiCall(`/overtime/${requestId}/approve`, "POST", { status_reason });

export const rejectOvertimeRequest = (requestId, status_reason = "") =>
  apiCall(`/overtime/${requestId}/reject`, "POST", { status_reason });

export const cancelOvertimeRequest = (requestId, cancelReason = "") =>
  apiCall(`/overtime/${requestId}/cancel`, "POST", { cancel_reason: cancelReason });
